module.exports = __webpack_public_path__ + "static/group-6-9a2fc7d53785bc649fac22f01a3eeab3.svg";